<template>
  <div>
    <EsHeaderView />
    <div class="container-box">
      <div class="app-container">
        <div class="page-title">{{ $t('message.home.announcements') }}</div>
        <div v-loading="loading">
          <div class="announcement-list" v-if="list.length">
            <div class="announcement-item" v-for="item in list" :key="item.id" @click="openDetail(item)">
              <div class="announcement-title">{{ item.title }}</div>
              <div class="announcement-date">{{ item.publishTime }}</div>
            </div>
          </div>
          <el-empty v-if="!list.length && !loading" :description="$t('message.home.noData')" />
          <div class="common-pagination" v-if="total > 0">
            <el-pagination background layout="prev,pager,next,total" :page-size="queryParams.pageSize"
              :current-page="queryParams.pageNumber" :total="total" @current-change="currentChange" />
          </div>
        </div>
      </div>
    </div>

    <el-dialog :title="currentItem.title" :visible.sync="dialogVisible" width="700px">
      <div class="announcement-content" v-html="currentItem.content" />
    </el-dialog>

    <EsFooterView />
  </div>
</template>

<script>
import { listAnnouncement } from "@/api/upms/announcement";

export default {
  name: "AnnouncementList",
  data() {
    return { loading: false, list: [], total: 0, dialogVisible: false, currentItem: {},
      queryParams: { pageNumber: 1, pageSize: 20 } }
  },
  created() { this.loadData() },
  methods: {
    loadData() {
      this.loading = true
      listAnnouncement(this.queryParams).then(r => {
        this.list = r.data?.data?.content || []
        this.total = r.data?.data?.total || 0
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    currentChange(page) { this.queryParams.pageNumber = page; this.loadData() },
    openDetail(item) { this.currentItem = item; this.dialogVisible = true }
  }
}
</script>

<style lang="scss" scoped>
.container-box { background: #f5f5f5; min-height: calc(100vh - 120px); }
.app-container { width: 1200px; margin: 0 auto; padding: 30px 0; }
.page-title { font-size: 22px; font-weight: bold; margin-bottom: 20px; }
.announcement-list { background: #fff; border-radius: 8px; overflow: hidden; }
.announcement-item { display: flex; align-items: center; justify-content: space-between; padding: 18px 24px; border-bottom: 1px solid #f0f0f0; cursor: pointer; transition: background .15s; }
.announcement-item:hover { background: #f5f7fa; }
.announcement-title { font-size: 15px; color: #303133; font-weight: 500; }
.announcement-date { font-size: 13px; color: #909399; }
.announcement-content { font-size: 14px; line-height: 1.8; color: #303133; }
.common-pagination { margin-top: 24px; text-align: center; }
</style>
